(() => {
  'use strict';
  
const $=id=>document.getElementById(id);
const bootEl=$('yds-boot'),boot=bootEl?JSON.parse(bootEl.textContent):null;
const pageOrigin=boot?new URL(document.baseURI).origin:location.origin;
const apiBase=boot?String(boot.apiBase||'').replace(/\/$/,''):'http://localhost:5176';
let session='',configState={},artReady=false,artError='',localRehearsalToken='',activeBlobUrl=null,imageLoadSerial=0,verifiedForHash='';
async function api(path,body){
 const headers={'ngrok-skip-browser-warning':'1'};
 if(!boot&&localRehearsalToken)headers['X-YDS-Local-Rehearsal']=localRehearsalToken;
 const opts={cache:'no-store',redirect:'error',signal:AbortSignal.timeout(path==='/api/cart-configuration'?120000:30000),headers};
 if(body!==undefined){opts.method='POST';headers['Content-Type']='application/json';headers['X-YDS-Session']=session;opts.body=JSON.stringify(body);}
 const r=await fetch(apiBase+path,opts);const data=await r.json();
 if(!r.ok)throw Error(data.error||'The customiser is temporarily unavailable.');return data;
}
const memoryKeys=new Map();
function savedKey(kind,data){
 const key='YDS-submission-'+kind+'-'+item.id,value=JSON.stringify(data);
 let previous=memoryKeys.get(key);
 try{previous=JSON.parse(sessionStorage.getItem(key))||previous;}catch{}
 if(previous?.value===value)return previous.key;
 const next={key:crypto.randomUUID(),value};memoryKeys.set(key,next);
 try{sessionStorage.setItem(key,JSON.stringify(next));}catch{}
 return next.key;
}
async function verification(action){
 if(configState.rehearsal)return '';
 if(!configState.turnstileSiteKey)throw Error('Verification has not been configured.');
 if(!window.turnstile){
  await new Promise((resolve,reject)=>{const script=document.createElement('script');
   script.src='https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
   script.onload=resolve;script.onerror=()=>reject(Error('Unable to load verification.'));document.head.append(script);});
 }
 return await new Promise((resolve,reject)=>{
  const box=$('verificationBox');
  const parent=$('checkoutButton').parentElement;
  const anchor=$('checkoutButton');
  parent.insertBefore(box,anchor);box.hidden=false;box.replaceChildren();
  let widget,settled=false;
  const timer=setTimeout(()=>finish(Error('Verification timed out. Please try again.')),120000);
  function finish(error,token){
   if(settled)return;settled=true;clearTimeout(timer);
   if(widget!==undefined)window.turnstile.remove(widget);box.hidden=true;
   if(error)reject(error);else resolve(token);
  }
  widget=window.turnstile.render(box,{sitekey:configState.turnstileSiteKey,action,
   callback:token=>finish(null,token),
   'error-callback':()=>finish(Error('Verification failed. Please try again.')),
   'expired-callback':()=>finish(Error('Verification expired. Please try again.'))});
 });
}
  const currency=new Intl.NumberFormat('en-NZ',{style:'currency',currency:'NZD'});
  let items=[], item=null, imageW=1400, imageH=780, zoom=1.15;
  let crop={x:.12,y:.12,width:.76,height:.76};
  let dragging=null, valid=true, modalFocus=null;
  let checkoutReady=false, previewDraftTestReady=false, checkoutPending=false;
  const standalone=Boolean(window.__YDS_PREVIEW__);
  const requestedEmbed=Boolean(boot)||new URLSearchParams(location.search).get('embed')==='1';
  let storefrontOrigin=null, embedReady=false;

  function clamp(v,min,max){return Math.max(min,Math.min(max,v));}
  // Snap near the outer edge so crop co-ordinates reach precisely 0 or 1,
  // rather than stopping at a tiny sliver because of pointer precision.
  function snapEdge(v,size){
    const max=Math.max(0,1-size),safe=clamp(v,0,max);
    const tolerance=Math.min(.012,max/3);
    return safe<=tolerance?0:(max-safe<=tolerance?max:safe);
  }
  function normalDimensions(){
    const w=Number($('wallWidth').value),h=Number($('wallHeight').value);
    if(!Number.isFinite(w)||!Number.isFinite(h)||w<100||h<100){throw Error('Enter a width and height of at least 100 cm.');}
    if(w>1e7||h>1e7)throw Error('Please contact our studio for an unusually large project.');
    return {w,h};
  }
  function calculate(){
    const {w,h}=normalDimensions(), amount=Math.max(199,Math.round(w*h*199/10000*100)/100);
    return {w,h,amount,printWidth:w+5,printHeight:h+5,area:w*h/10000};
  }
  function currentPayload(){
    
    const p=calculate();
    return {productId:item.id, shopifyProductId:item.shopifyProductId, artworkHash:item.artworkHash||null, widthCm:p.w,heightCm:p.h,
      crop:{x:+crop.x.toFixed(6),y:+crop.y.toFixed(6),width:+crop.width.toFixed(6),height:+crop.height.toFixed(6),imageWidth:imageW,imageHeight:imageH},
      clientEstimateNZD:p.amount};
  }
  function calculateBox(preserveCenter=true){
    let w,h;try{({w,h}=calculate());}catch{w=100;h=100;}
    // At 100% use the maximum crop that fits the selected wall ratio, without
    // the previous 6% inset. This lets customers include the extreme edges.
    const target=(w/h)/(imageW/imageH);
    const baseW=Math.min(1,target),baseH=baseW/target;
    const nw=baseW/zoom, nh=baseH/zoom;
    const cx=preserveCenter?crop.x+crop.width/2:.5,cy=preserveCenter?crop.y+crop.height/2:.5;
    crop.width=nw;crop.height=nh;crop.x=snapEdge(cx-nw/2,nw);crop.y=snapEdge(cy-nh/2,nh);
    drawCrop();
  }
  function drawCrop(){
    const pct=n=>(100*n)+'%';
    const c=$('crop');
    c.style.left=pct(crop.x);c.style.top=pct(crop.y);c.style.width=pct(crop.width);c.style.height=pct(crop.height);
    const set=(id,left,top,width,height)=>{const el=$(id);el.style.left=pct(left);el.style.top=pct(top);el.style.width=pct(Math.max(0,width));el.style.height=pct(Math.max(0,height));};
    set('shadeTop',0,0,1,crop.y);set('shadeBottom',0,crop.y+crop.height,1,1-crop.y-crop.height);
    set('shadeLeft',0,crop.y,crop.x,crop.height);set('shadeRight',crop.x+crop.width,crop.y,1-crop.x-crop.width,crop.height);
  }
  function syncCartAvailability(){
    const button=$('checkoutButton');button.disabled=checkoutPending||!checkoutReady||!valid||!artReady;
    if(boot?.previewOnly===true){button.disabled=true;button.textContent='PREVIEW ONLY';button.setAttribute('aria-disabled','true');$('checkoutNote').textContent='Preview only - ordering for this mural has not been activated.';return;}
    if(!checkoutPending)button.textContent=checkoutReady?'ADD TO CART':'CURRENTLY UNAVAILABLE';
    button.setAttribute('aria-disabled',String(button.disabled));
    if(!checkoutReady)$('checkoutNote').textContent='Ordering is temporarily unavailable. Your crop is saved on this device; please try again later.';
    else if($('checkoutNote').textContent==='Ordering is temporarily unavailable. Your crop is saved on this device; please try again later.')$('checkoutNote').textContent='Your mural is ready to add to your cart.';
  }
  function updateNumbers(){
    try{
      const p=calculate();valid=true;$('sizeError').hidden=!artError;if(artError)$('sizeError').textContent=artError;syncCartAvailability();
      $('price').textContent=currency.format(p.amount);
      calculateBox(true);
    }catch(err){valid=false;$('sizeError').textContent=err.message;$('sizeError').hidden=false;
      $('price').textContent='\u2014';$('checkoutButton').disabled=true;
    }
  }
  function artworkFailure(message){
    artReady=false;artError=message;valid=false;
    $('artwork').setAttribute('aria-busy','false');$('artwork').setAttribute('data-image-state','error');
    $('checkoutButton').disabled=true;$('downloadProof').disabled=true;
    $('sizeError').hidden=false;$('sizeError').textContent=message;
  }
  async function loadVerifiedImage(p,img){
    const serial=++imageLoadSerial;
    try{
      if(standalone||!p.artworkHash){img.src=p.image;return;}
      const r=await fetch(p.image,{mode:'cors',credentials:'omit',headers:{Accept:'image/jpeg,image/png'},signal:AbortSignal.timeout(18000)});
      if(!r.ok)throw Error('Image unavailable');
      const blob=await r.blob();
      if(blob.size>20000000)throw Error('Image too large');
      const hash=[...new Uint8Array(await crypto.subtle.digest('SHA-256',await blob.arrayBuffer()))].map(v=>v.toString(16).padStart(2,'0')).join('');
      if(hash!==p.artworkHash)throw Error('Artwork version changed');
      if(serial!==imageLoadSerial)return;
      if(activeBlobUrl)URL.revokeObjectURL(activeBlobUrl);
      activeBlobUrl=URL.createObjectURL(blob);verifiedForHash=p.artworkHash;img.src=activeBlobUrl;
    }catch{if(serial!==imageLoadSerial)return;artworkFailure('We could not verify this artwork version. Please reopen the mural or contact our studio. No order has been placed.');}
  }

  function selectProduct(next){
    const p=items.find(o=>o.id===next)||items[0];if(!p)return;
    item=p;artReady=false;artError='';verifiedForHash='';dragging=null;imageW=p.previewWidth||1400;imageH=p.previewHeight||780;zoom=1;$('zoom').value='1';$('zoomValue').textContent='100%';$('downloadProof').disabled=true;$('artwork').style.setProperty('--artwork-ratio',imageW+' / '+imageH);$('artwork').setAttribute('data-image-state','loading');calculateBox(false);$('checkoutButton').disabled=true;$('artTitle').textContent=p.name;$('artColour').textContent=[p.colour,p.collection||'Quiet Worlds'].filter(Boolean).join(' \u00b7 ');
    const img=$('artImage');img.onload=null;img.onerror=null;img.removeAttribute('src');$('artwork').setAttribute('aria-busy','true');img.onload=function(){ if(item!==p)return;if(p.artworkHash&&!standalone&&(verifiedForHash!==p.artworkHash||img.src!==activeBlobUrl))return; $('artwork').setAttribute('aria-busy','false');imageW=img.naturalWidth;imageH=img.naturalHeight;if(!imageW||!imageH||(p.previewWidth&&imageW!==p.previewWidth)||(p.previewHeight&&imageH!==p.previewHeight)){artworkFailure('Artwork dimensions do not match the reviewed source. No order has been placed.');return;}$('artwork').style.setProperty('--artwork-ratio',imageW+' / '+imageH);$('artwork').setAttribute('data-image-state','ready');artReady=true;artError='';$('downloadProof').disabled=false;zoom=1;$('zoom').value='1';$('zoomValue').textContent='100%';crop={x:0,y:0,width:1,height:1};calculateBox(false);
      try{
       const old=JSON.parse(sessionStorage.getItem('YDS-crop-'+p.id));
       if(old&&old.version!==(p.artworkHash||p.image)){$('checkoutNote').textContent='This mural preview has been updated. Please select your crop again before adding it to your cart.';sessionStorage.removeItem('YDS-crop-'+p.id);}
       if(old&&old.version===(p.artworkHash||p.image)&&old.crop){
        $('wallWidth').value=old.width;$('wallHeight').value=old.height;zoom=old.zoom;$('zoom').value=String(zoom);
        $('zoomValue').textContent=Math.round(100*zoom)+'%';updateNumbers();crop=old.crop;drawCrop();
       }
      }catch{}
      updateNumbers();
    };
    img.onerror=()=>{if(item!==p)return;artworkFailure('Artwork could not be loaded. Please refresh or contact our studio.');};loadVerifiedImage(p,img);img.alt=p.name+' in '+p.colour+', complete mural artwork';
    $('roomImage').src=p.roomImage;
  }
  function showModal(id){modalFocus=document.activeElement;const close=$('closeEmbed');if(close){close.dataset.modalHidden=String(close.hidden);close.hidden=true;}$(id).hidden=false;document.body.style.overflow='hidden';$(id).querySelector('button,[name]')?.focus();}
  function closeModal(el){const overlay=el.closest('.overlay');if(!overlay)return;overlay.hidden=true;document.body.style.overflow='';const close=$('closeEmbed');if(close&&close.dataset.modalHidden!==undefined){close.hidden=close.dataset.modalHidden==='true';delete close.dataset.modalHidden;}modalFocus?.focus();}
  async function makeProof(){
    if(!artReady||!valid)return;
    const button=$('downloadProof');button.disabled=true;
    try{
      const p=currentPayload(),img=$('artImage'),canvas=document.createElement('canvas');
      const sx=p.crop.x*img.naturalWidth,sy=p.crop.y*img.naturalHeight;
      const sw=p.crop.width*img.naturalWidth,sh=p.crop.height*img.naturalHeight;
      if(!(sw>0&&sh>0))throw Error('Crop image is not ready.');
      canvas.width=Math.max(1,Math.round(sw));canvas.height=Math.max(1,Math.round(sh));
      const context=canvas.getContext('2d');if(!context)throw Error('Image download is unavailable in this browser.');
      context.drawImage(img,sx,sy,sw,sh,0,0,canvas.width,canvas.height);
      const blob=await new Promise((resolve,reject)=>canvas.toBlob(value=>value&&value.size>0&&value.type==='image/png'?resolve(value):reject(Error('Could not create the crop image.')),'image/png'));
      const url=URL.createObjectURL(blob),link=document.createElement('a');
      link.href=url;link.download='YDS-'+item.id+'-'+p.widthCm+'x'+p.heightCm+'cm-crop.png';link.style.display='none';document.body.append(link);link.click();link.remove();
      setTimeout(()=>URL.revokeObjectURL(url),60000);
      $('checkoutNote').textContent='Your cropped PNG image is ready to save or view.';
    }catch(error){$('checkoutNote').textContent=error.message;}
    finally{button.disabled=!artReady||!valid;}
  }
  async function reviewCheckout({confirmReadd=false}={}){
    if(!checkoutReady){syncCartAvailability();return;}
    if(!valid||!artReady)return;
    if(checkoutPending)return;
    if(checkoutReady){
      checkoutPending=true;const b=$('checkoutButton');b.disabled=true;b.textContent='PREPARING YOUR MURAL...';
      $('checkoutNote').textContent='Preparing your exact crop. This can take up to a minute. Keep this page open; your crop is saved.';
      try {
        const payload=currentPayload();payload.submissionKey=savedKey('shared-cart',payload);
        payload.captchaToken=await verification('mural-checkout');
        const config=await api('/api/cart-configuration',payload);
        b.textContent='ADDING TO CART...';$('checkoutNote').textContent='Your mural is saved. Checking and updating your cart...';
        if(!window.YdsSharedCart)throw Error('Cart support unavailable. Refresh to try again.');
        const added=await window.YdsSharedCart(config,{confirmReadd});
        $('checkoutNote').textContent=added.alreadyPresent?'This saved mural is already in your cart. Change the number of copies in your cart.':'Your mural is in your cart. Continue shopping or open your cart.';
        const link=document.createElement('a');link.href=(window.Shopify?.routes?.root||'/')+'cart';link.textContent='Open cart';link.className='secondary';link.style.cssText='display:block;float:none;position:static;width:100%;max-width:100%;box-sizing:border-box;white-space:normal;text-align:center;margin:12px 0 0;padding:12px 14px;line-height:1.4;';
        $('checkoutNote').append(document.createTextNode(' '),link);
      } catch(err){$('checkoutNote').textContent=err.name==='TimeoutError'?'The request timed out. Your crop is saved. Check your cart before retrying this same selection.':err.message;
        if(err.code==='CONFIRM_READD'){const again=document.createElement('button');again.type='button';again.className='secondary';again.textContent='Add one copy again';again.style.cssText='display:block;width:100%;margin-top:12px';again.addEventListener('click',()=>reviewCheckout({confirmReadd:true}));$('checkoutNote').append(again);again.focus();}
      }
      finally {checkoutPending=false;syncCartAvailability();}return;
    }
  }
  function persistCrop(){
    if(!item||!valid||!artReady)return;
    try{sessionStorage.setItem('YDS-crop-'+item.id,JSON.stringify({version:item.artworkHash||item.image,
      width:Number($('wallWidth').value),height:Number($('wallHeight').value),zoom,crop}));}catch{}
  }
  function wire(){
    for(const id of ['wallWidth','wallHeight','zoom'])$(id).addEventListener('change',persistCrop);
    $('artwork').addEventListener('pointerup',persistCrop);
    $('artwork').addEventListener('keyup',persistCrop);

    $('wallWidth').addEventListener('input',updateNumbers);$('wallHeight').addEventListener('input',updateNumbers);
    $('zoom').addEventListener('input',e=>{zoom=+e.target.value;$('zoomValue').textContent=Math.round(100*zoom)+'%';calculateBox();});
    $('resetCrop').addEventListener('click',()=>{zoom=1;$('zoom').value=zoom;$('zoomValue').textContent='100%';calculateBox(false);persistCrop();});
    function startCropDrag(e,centreOnClick){
      
      if(!valid||!artReady||(e.pointerType==='mouse'&&e.button!==0))return;
      e.preventDefault();
      const artwork=$('artwork'),r=artwork.getBoundingClientRect();
      // Clicking the shaded area places the selection there, useful on mobile
      // and for jumping to the far right or bottom of an extra-wide design.
      if(centreOnClick){
        crop.x=snapEdge((e.clientX-r.left)/r.width-crop.width/2,crop.width);
        crop.y=snapEdge((e.clientY-r.top)/r.height-crop.height/2,crop.height);
        drawCrop();
      }
      artwork.setPointerCapture(e.pointerId);
      dragging={id:e.pointerId,x:e.clientX,y:e.clientY,startX:crop.x,startY:crop.y};
    }
    $('crop').addEventListener('pointerdown',e=>{e.stopPropagation();startCropDrag(e,false);});
    $('artwork').addEventListener('pointerdown',e=>{
      if($('crop').contains(e.target))return;
      startCropDrag(e,true);
    });
    $('artwork').addEventListener('pointermove',e=>{
      if(!dragging||e.pointerId!==dragging.id)return;
      const r=$('artwork').getBoundingClientRect();
      crop.x=snapEdge(dragging.startX+(e.clientX-dragging.x)/r.width,crop.width);
      crop.y=snapEdge(dragging.startY+(e.clientY-dragging.y)/r.height,crop.height);
      drawCrop();
    });
    for(const n of ['pointerup','pointercancel','lostpointercapture'])$('artwork').addEventListener(n,()=>dragging=null);
    $('artwork').addEventListener('keydown',e=>{const m={ArrowRight:[1,0],ArrowLeft:[-1,0],ArrowDown:[0,1],ArrowUp:[0,-1]};if(!m[e.key])return;e.preventDefault();const step=e.shiftKey?.025:.008;crop.x=clamp(crop.x+m[e.key][0]*step,0,1-crop.width);crop.y=clamp(crop.y+m[e.key][1]*step,0,1-crop.height);drawCrop();});
    $('toggleRoom').addEventListener('click',()=>showModal('roomDialog'));
    $('checkoutButton').addEventListener('click',()=>reviewCheckout());
    window.addEventListener('pageshow',()=>{if(item&&artReady)updateNumbers();});
    $('verifySetup')?.addEventListener('click',async()=>{
      const b=$('verifySetup');if(!valid||!artReady)return;b.disabled=true;
      try{const payload=currentPayload();payload.captchaToken=await verification('mural-checkout');
        const r=await api('/api/validate-selection',payload);
        if(!r.verificationPassed)throw Error('Verification was not completed.');
        $('checkoutNote').textContent='Connection, verification and $'+r.dimensions.priceNZD+' price passed. No order created or email sent.';
      }catch(e){$('checkoutNote').textContent=e.message;}finally{b.disabled=false;}
    });

    $('downloadProof').addEventListener('click',makeProof);
    document.querySelectorAll('[data-close]').forEach(b=>b.addEventListener('click',()=>closeModal(b)));
    document.querySelectorAll('.overlay').forEach(o=>o.addEventListener('click',e=>{if(e.target===o)closeModal(o.querySelector('.dialog'));}));
    document.addEventListener('keydown',e=>{if(e.key==='Escape'){
      const o=[...document.querySelectorAll('.overlay')].find(x=>!x.hidden);
      if(o)closeModal(o.querySelector('.dialog'));
      else if(boot&&window.parent!==window)window.parent.postMessage({type:'YDS_CUSTOMISER_CLOSE'},pageOrigin);
    }});
  }
  async function start(){
    wire();syncCartAvailability();
    let config;
    if(standalone){items=window.__YDS_CATALOGUE__;config={checkoutReady:false,enquiriesReady:false};}
    else{
      if(!boot){try{const l=await fetch('/api/local-rehearsal',{cache:'no-store'});if(l.ok){const d=await l.json();if(d.enabled)localRehearsalToken=d.token||'';}}catch{}}
      config=await api('/api/config');session=config.session||'';
      if(boot){
        let mapped;
        if(boot.previewOnly===true){
          const previewResponse=await fetch(boot.previewCatalogue,{credentials:'omit',signal:AbortSignal.timeout(18000)});
          if(!previewResponse.ok)throw Error('Preview catalogue unavailable');
          const previewRows=await previewResponse.json();
          mapped=previewRows.find(p=>p.shopifyProductId===String(boot.product.shopifyProductId));
          if(!mapped)throw Error('Product is not in the reviewed preview catalogue');
          config={...config,sharedCartReady:false,checkoutReady:false,previewDraftTestReady:false};
        }else{mapped=await api('/api/product?id='+encodeURIComponent(boot.product.shopifyProductId));}
        let image=mapped.remoteImage||boot.product.image;
        if(!mapped.remoteImage&&boot.product.artworkEncoding==='base64-json'){
          const source=await fetch(image,{credentials:'omit',redirect:'error',signal:AbortSignal.timeout(18000)});
          if(!source.ok)throw Error('Artwork source unavailable');
          const encoded=await source.json();
          if(typeof encoded.dataUrl!=='string'||encoded.dataUrl.length>28000000||!/^data:image\/jpeg;base64,[A-Za-z0-9+/]+={0,2}$/.test(encoded.dataUrl))throw Error('Invalid artwork source');
          image=encoded.dataUrl;
        }
        items=[{...boot.product,...mapped,image,roomImage:boot.product.roomImage,collection:boot.product.collection}];
      }else{const r=await fetch('/catalogue.json',{cache:'no-store'});items=(await r.json()).filter(p=>p.disabled!==true);}
    }
    configState=config;
    if($('verifySetup'))$('verifySetup').hidden=true; // Unpublished preview: real verification, no order.
    previewDraftTestReady=Boolean(config.previewDraftTestReady);
    embedReady=Boolean(boot)||Boolean(config.embedReady);storefrontOrigin=boot?pageOrigin:(config.storefrontOrigin||null);
    if(requestedEmbed)document.documentElement.classList.add('yds-embedded');
    const closeEmbed=$('closeEmbed');
    if(requestedEmbed){closeEmbed.hidden=false;closeEmbed.addEventListener('click',()=>{
      if(embedReady&&storefrontOrigin&&window.parent!==window)window.parent.postMessage({type:'YDS_CUSTOMISER_CLOSE'},storefrontOrigin);
      else if(boot){const url=new URL(location.href);url.searchParams.delete('view');location.assign(url.href);}
      else if(window.history.length>1)window.history.back();
    });}

    checkoutReady=config.sharedCartReady===true;syncCartAvailability();
    const picker=$('designPicker');items.forEach(p=>{const opt=document.createElement('option');opt.value=p.id;opt.textContent=p.name+' \u00b7 '+p.colour;picker.append(opt)});
    const requested=boot?items[0].id:(new URLSearchParams(location.search).get('design')||'velvet-horizon');picker.value=items.some(p=>p.id===requested)?requested:items[0].id;
    if(boot){document.querySelector('.demo-pick').hidden=true;document.querySelector('.masthead').hidden=true;document.querySelector('.footline').hidden=true;}
    picker.addEventListener('change',()=>selectProduct(picker.value));selectProduct(picker.value);updateNumbers();
  }
  document.addEventListener('keydown',e=>{
 if(e.key!=='Tab')return;const box=[...document.querySelectorAll('.overlay')].find(x=>!x.hidden);
 if(!box)return;const els=[...box.querySelectorAll('button:not([disabled]),input,textarea,select,a[href]')].filter(x=>x.offsetParent!==null);
 if(!els.length)return;if(e.shiftKey&&document.activeElement===els[0]){e.preventDefault();els.at(-1).focus();}
 else if(!e.shiftKey&&document.activeElement===els.at(-1)){e.preventDefault();els[0].focus();}
});
start().then(()=>{if(boot&&window.parent!==window)window.parent.postMessage({type:'YDS_CUSTOMISER_READY'},pageOrigin);}).catch(err=>{console.error(err);$('sizeError').textContent='Unable to load product artwork. Refresh to try again.';$('sizeError').hidden=false;});
})();


